import React, { useRef, useEffect } from 'react'
import { Button } from '../../../Button/Button'
import styles from '../../Forms.module.scss'

type OnChange = (name: string, files: FileList, fileName: string) => void

interface FileInputProps {
  name: string
  onChange: OnChange
  label: string
  small?: boolean
  value: string
  accept?: string
}

const FileInput: React.FC<FileInputProps> = ({
  name,
  onChange,
  label,
  small = false,
  value,
  accept = ''
}) => {
  const fileInputRef = useRef<HTMLInputElement>(null)

  useEffect(() => {
    // Clear the file input when value is cleared externally
    if (fileInputRef.current && value === '') {
      fileInputRef.current.value = ''
    }
  }, [value])

  const setFile = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files
    const inputValue = e.target.value

    if (files && files.length > 0) {
      onChange(name, files, inputValue)
    }
  }

  // Function to trigger file input click
  const handleButtonClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click()
    }
  }

  // Extract filename from the full path
  const fileName = value ? value.split('\\').pop() : 'No file selected'

  return (
    <div className={`${styles.narrowFormInput}`}>
      <div className={styles.imgLabel}>
        {label && (
          <label className={small ? styles.smallLabel : ''} htmlFor={name}>
            {label}
          </label>
        )}
      </div>
      <div className={styles.fileInputWrapper}>
        {/* Hidden file input */}
        <input
          className={styles.hiddenFileInput}
          ref={fileInputRef}
          type='file'
          id={name}
          onChange={setFile}
          accept={accept}
        />

        {/* Custom file input button */}
        <div className={styles.fileInputControls}>
          <Button
            handleClick={handleButtonClick}
            className='btn--ghost--primary'
            style={{
              height: small ? '30px' : '36px',
              fontSize: small ? '13px' : '15px'
              // padding: '0 15px'
            }}
          >
            Choose File
          </Button>
        </div>
        <p style={{ marginTop: '2px' }}>
          File: <span className={styles.fileName}> {fileName}</span>
        </p>
      </div>
    </div>
  )
}

export default FileInput
